import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Kidsclub(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_376_90)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M19 1a1 1 0 01.916.6l3.807 8.714a2.583 2.583 0 01-3.22 3.472l-2.07-.725a13.519 13.519 0 002.961 4.913c.324-.233.648-.482.973-.748a1 1 0 111.266 1.548C17.83 23.522 11.977 23.53 7.612 22.34a21.892 21.892 0 01-6.696-3.155 13.541 13.541 0 01-.505-.376l-.03-.024-.006-.004a1 1 0 111.261-1.552l.017.013.081.063a16.344 16.344 0 00.856.6A25.112 25.112 0 005.51 13H3a3 3 0 110-6h8.247c.925-2.835 2.73-4.358 4.383-5.152a8.925 8.925 0 012.316-.74 7.825 7.825 0 01.956-.106A3.42 3.42 0 0118.967 1h.031S19 1 19 2V1zm-2.23 13.336a15.557 15.557 0 002.91 4.73c-.53.298-1.06.555-1.584.777A6.916 6.916 0 0011.901 16h-.093a6.775 6.775 0 00-5.99 3.61 20.387 20.387 0 01-1.485-.692A27.234 27.234 0 007.69 12.99c.09-.22.175-.44.254-.665l.001-.002A1 1 0 007 11H3a1 1 0 110-2h9a1 1 0 00.97-.757c.669-2.675 2.194-3.953 3.525-4.591a6.926 6.926 0 011.879-.587l3.516 8.05a.583.583 0 01-.727.783l-3.833-1.342a1 1 0 00-1.321 1.075v.001c.035.267.094.531.157.793.113.475.302 1.138.605 1.911zm-9.042 5.957A4.775 4.775 0 0111.808 18h.093c1.793 0 3.421.973 4.282 2.502-2.96.799-5.727.54-8.045-.092a18.362 18.362 0 01-.41-.117z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_376_90"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default Kidsclub;